import { useSelector } from 'react-redux';
import cn from 'classnames';

import type { WithTestId } from 'types/app';

import { selectLanguage } from '@Modules/app/selectors';
import type { OfferMarkupType, OfferType, TranslationType } from '@Modules/offers/types';

import { Loan } from '@Atomic/organisms/Loan';
import { OfferDetails } from '@Atomic/organisms/offer/OfferDetails';
import { OfferRelated } from '@Atomic/organisms/offer/OfferRelated';
import { OfferTop } from '@Atomic/organisms/offer/OfferTop';
import { OfferCardBanner } from '@Atomic/molecules/OfferCardBanner';

import styles from './style.module.scss';

type Props = WithTestId<{
  offer: OfferType;
  isExpired: boolean;
  translation?: TranslationType;
  className?: string;
  markup?: OfferMarkupType;
  onGoBack?: () => void;
}>;

export const MainInfo = ({
  offer,
  isExpired,
  translation,
  testId,
  markup,
  className,
  onGoBack,
}: Props) => {
  const lang = useSelector(selectLanguage);
  const lastBreadCrumb = markup?.breadcrumbs[markup.breadcrumbs.length - 1];

  return (
    <div className={cn(styles.mainInfo, className)} data-testid={testId}>
      <div className={cn(styles.mainInfoContent, styles.wrapper)}>
        <OfferTop
          className={styles.offerTop}
          variant="actionsOnly"
          offer={offer}
          isExpired={isExpired}
          onGoBack={onGoBack}
        />

        <OfferDetails offer={offer} isExpired={isExpired} translation={translation} />
      </div>

      {isExpired && lastBreadCrumb && <OfferRelated url={`/${lastBreadCrumb.webUriInfo[lang]}`} />}

      <Loan
        offerId={offer.id}
        className={cn(styles.wrapper)}
        price={offer.priceUzs}
        isBusiness={offer.seller.business}
      />

      <OfferCardBanner />
    </div>
  );
};
